import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="guarantee-title" className="bg-brand-sand px-4 py-20" data-id="element-115" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-116" data-mp="9tbcar65iefn">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-117" data-mp="etfxgui07xc7">
          <ShieldCheckIcon className="h-8 w-8 text-brand-teal" aria-hidden="true" data-id="element-118" data-mp="jt2bv79kjjml" />
        </div>
        <h2 id="guarantee-title" className="text-2xl font-extrabold tracking-tight text-brand-primary md:text-3xl" data-id="element-119" data-mp="ntm53zr0u33g">
          🛡 Rimborso Garantito o Lo Tieni Comunque.
        </h2>
        <p className="mx-auto mt-6 max-w-xl leading-relaxed text-brand-gray" data-id="element-120" data-mp="xk73pn6p37md">
          Se <strong className="font-bold text-brand-text" data-id="element-121" data-mp="12ja58xnguvpl">EDUCAZIONE FISICA PRONTA™</strong> non fa al caso tuo,
          scrivici <strong className="font-bold text-brand-text" data-id="element-122" data-mp="17hbnjgd2ir00">entro 30 giorni</strong> per il{' '}
          <strong className="font-bold text-brand-text" data-id="element-123" data-mp="25s71sim5hf8d">rimborso completo</strong>. Nessuna domanda. E se decidi di
          tenerlo, <strong className="font-bold text-brand-text" data-id="element-124" data-mp="20s2lasl8ski5">resta tuo per sempre</strong>.
        </p>
      </Reveal>
    </section>;
}